import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  changePasswordResponseObject: any = {};
  changePasswordRequestObject: any = {};
  role: any;
  roleName : string;
  //resetFields:any;


  constructor( private dashboardService: DashboardService, private router: Router,private toastr: ToastrService) {
    this.role = localStorage.role;
    if (this.role == '1') {
      this.roleName = 'admin';
    } else if (this.role == '2') {
      this.roleName = 'epc';
    }else if(this.role == '3'){
      this.roleName = 'wms';
    }else if(this.role == '4'){
      this.roleName = 'normal';
    }else if(this.role == '6'){
      this.roleName = 'ze';
    }else if(this.role == '7'){
      this.roleName = 'dg';
    }
  }


  ngOnInit() {
  }


    // Admin Change Password
    adminChangePassword(changePasswordRequestObject) {

      this.dashboardService
        .adminChangePassword(changePasswordRequestObject).subscribe(
          async data => {
            if (data.status) {
              this.toastr.success(data.message);
              this.router.navigate(["inject-solar/dashboard"]);
            } else if(!data.status) {
              this.toastr.info(data.message);
              // this.router.navigate(["inject-solar/dashboard"]);
            }else if(data.message == 'Unauthorised or Login Time-out')
            {
              this.toastr.info('Login Time-out .. Please login again');
              this.router.navigate(["/login"]);
            }
          },
          err => {
            return console.error(err);
          }
        );
    }

    // Epc Change Password

   epcChangePassword(changePasswordRequestObject) {
    this.dashboardService
      .epcChangePassword(changePasswordRequestObject).subscribe(
        async data => {

          if (data.status) {
            this.toastr.success(data.message);
            this.router.navigate(["inject-solar/dashboard"]);
          } else if(!data.status) {
            this.toastr.info(data.message);
            // this.router.navigate(["inject-solar/dashboard"]);
          }else if(data.message == 'Unauthorised or Login Time-out')
          {
            this.toastr.info('Login Time-out .. Please login again');
            this.router.navigate(["/login"]);
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  normalChangePassword(changePasswordRequestObject){
    this.dashboardService
      .normalChangePassword(changePasswordRequestObject).subscribe(
        async data => {
          if (data.status) {
            this.toastr.success(data.message);
            this.router.navigate(["inject-solar/dashboard"]);
          } else if(!data.status) {
            this.toastr.info(data.message);
            // this.router.navigate(["inject-solar/dashboard"]);
          }else if(data.message == 'Unauthorised or Login Time-out')
          {
            this.toastr.info('Login Time-out .. Please login again');
            this.router.navigate(["/login"]);
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  wmsuserChangePassword(changePasswordRequestObject){
    this.dashboardService
      .wmsChangePassword(changePasswordRequestObject).subscribe(
        async data => {
          if (data.status) {
            this.toastr.success(data.message);
            this.router.navigate(["inject-solar/dashboard"]);
          } else if(!data.status) {
            this.toastr.info(data.message);
            // this.router.navigate(["inject-solar/dashboard"]);
          }else if(data.message == 'Unauthorised or Login Time-out')
          {
            this.toastr.info('Login Time-out .. Please login again');
            this.router.navigate(["/login"]);
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  zedguserChangePassword(changePasswordRequestObject){
    this.dashboardService
      .zedgChangePassword(changePasswordRequestObject).subscribe(
        async data => {
          if (data.status) {
            this.toastr.success(data.message);
            this.router.navigate(["inject-solar/dashboard"]);
          } else if(!data.status) {
            this.toastr.info(data.message);
            // this.router.navigate(["inject-solar/dashboard"]);
          }else if(data.message == 'Unauthorised or Login Time-out')
          {
            this.toastr.info('Login Time-out .. Please login again');
            this.router.navigate(["/login"]);
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

     // Update Password
    onUpdate(formData) {

      this.changePasswordRequestObject = {
        current_password: formData.value.oldPassword,
        new_password: formData.value.newPassword,
        confirm_password: formData.value.confirmPassword
      };
      if (this.role == '1') {
        this.adminChangePassword(this.changePasswordRequestObject);
      }
       else if (this.role == '2') {
        this.epcChangePassword(this.changePasswordRequestObject);
      }else if (this.role == '3') {
        this.wmsuserChangePassword(this.changePasswordRequestObject);
      }
      else if (this.role == '4') {
        this.normalChangePassword(this.changePasswordRequestObject);
      }
      else if (this.role == '6'||this.role == '7') {
        this.zedguserChangePassword(this.changePasswordRequestObject);
      }
  }


}
